import { defineMessages } from 'react-intl';

export const nativeEmbedToolbarMessages: {
    alwaysShowTitle: {
        id: string;
        defaultMessage: string;
        description: string;
    }; refresh: {
        id: string;
        defaultMessage: string;
        description: string;
    }; summarise: {
        id: string;
        defaultMessage: string;
        description: string;
    }; setEmbedType: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	alwaysShowTitle: {
		id: 'fabric.editor.alwaysShowTitle.non-final',
		defaultMessage: 'Show embed title',
		description:
			'Label for the toggle to enable or disable the behaviour of always showing the title of the embed.',
	},
	refresh: {
		id: 'fabric.editor.refresh.non-final',
		defaultMessage: 'Refresh',
		description: 'Label for the button to refresh the embedded link.',
	},
	summarise: {
		id: 'fabric.editor.nativeEmbeds.summarise',
		defaultMessage: 'Summarize',
		description: 'Label for the button to summarize the content of the embedded link using AI.',
	},
	setEmbedType: {
		id: 'fabric.editor.setEmbedType.non-final',
		defaultMessage: 'Set embed type',
		description: 'Label for the button to set the type of embed.',
	},
});
